// Frontend ingestion-template registry.
//
// Templates are imported as plain objects and inserted into the registry
// here.  We deliberately avoid the "template self-registers via
// side-effect import at the bottom of this file" pattern because ES
// modules hoist imports above the surrounding `const` initialisers,
// which would put the internal Map in the temporal dead zone when a
// template module runs.  Explicit imports at the top of this module
// execute after their dependencies (the types / IngestionTemplate
// interface) but the registry population happens in this module's body,
// after the Map is initialised.

import { haasSupplierSvhcTemplate } from "./ingestion/haas_supplier_svhc"
import type { IngestionTemplate } from "./types"

const _INGESTION: Map<string, IngestionTemplate> = new Map()

function register(template: IngestionTemplate): void {
  if (_INGESTION.has(template.id)) {
    throw new Error(`Ingestion template '${template.id}' already registered`)
  }
  _INGESTION.set(template.id, template)
}

// Register every known template.  Adding a new one is a two-liner here
// plus the new template module under ./ingestion/.
register(haasSupplierSvhcTemplate)

export function getIngestionTemplate(
  id: string,
): IngestionTemplate | undefined {
  return _INGESTION.get(id)
}

export function listIngestionTemplates(): IngestionTemplate[] {
  return [..._INGESTION.values()].sort((a, b) => a.id.localeCompare(b.id))
}

export function listIngestionTemplatesForAnchor(
  scopeId: string,
): IngestionTemplate[] {
  return listIngestionTemplates().filter((t) => t.anchorScopeId === scopeId)
}
